import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';
import { PermisosUsuariosI } from '../interface/usuario.interface';

@Injectable({ providedIn: 'root' })
export class PermisosUsuariosService {
  constructor(private readonly http: HttpClient) {}

  private readonly url = environment.url + 'permisos-usuarios/';

  getAll(params?: HttpParams) {
    return this.http.get<BackendResponse>(this.url, { params }).pipe(
      catchError((e) => handleError(e)),
      map(
        (data) =>
          data.result as { entities: PermisosUsuariosI[]; count: number }
      )
    );
  }

  update(id: number, data: Partial<PermisosUsuariosI>) {
    const direction = this.url + id;
    return this.http.put<BackendResponse>(direction, data).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as PermisosUsuariosI | string)
    );
  }

  insert(data: Partial<PermisosUsuariosI>) {
    return this.http
      .post<BackendResponse>(this.url + 'auth/register', data)
      .pipe(
        catchError((e) => handleError(e)),
        map((data) => data.result as PermisosUsuariosI)
      );
  }
}
